module.exports = __webpack_public_path__ + "media/images/bg-warning-5b6d758b33ef15816404a0afb02324dc.png";